import "./Solutions.module.css";
import Navigation from "@/reusable_sections/Header";
import Capabilities from "./sections/Capabilities";
import Integration from "./sections/Integration";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <Navigation />
      <Capabilities />
      <Integration />
      <Faq />
      <Footer />
    </div>;
}